interface ZaiusEvent {
  type: string;
  data: Record<string, unknown>;
}

declare global {
  interface Window {
    zaius?: {
      event: (type: string, data: Record<string, unknown>) => void;
    };
  }
}

/**
 * Tracks a search event in Zaius
 * @param searchTerm The search term entered by the user
 * @param resultsCount The number of results returned
 */
export const trackSearchEvent = (searchTerm: string, resultsCount: number): void => {
  if (!window.zaius) {
    console.warn('Zaius is not initialized');
    return;
  }

  const eventData: ZaiusEvent = {
    type: 'search',
    data: {
      search_term: searchTerm,
      results_count: resultsCount,
      timestamp: Math.floor(Date.now() / 1000).toString()
    }
  };

  try {
    window.zaius.event(eventData.type, eventData.data);
  } catch (error) {
    console.error('Failed to track search event:', error);
  }
};

/**
 * Gets the VUID from cookies and processes it to the correct format
 * @returns The VUID if found, null otherwise
 */
export const getVuidFromCookie = (): string | null => {
  try {
    const cookies = document.cookie.split(';');
    const vuidCookie = cookies.find(cookie => cookie.trim().startsWith('vuid='));
    if (!vuidCookie) return null;

    // Extract the VUID value
    const vuidValue = vuidCookie.split('=')[1];
    if (!vuidValue) return null;

    // The VUID format is "uuid|timestamp", we only need the UUID part
    const [uuid] = vuidValue.split('%7C');
    if (!uuid) return null;

    // Remove hyphens from UUID before using it
    const cleanUuid = uuid.replace(/-/g, '');
    if (!cleanUuid) return null;

    return cleanUuid;
  } catch (error) {
    console.error('Failed to get VUID from cookie:', error);
    return null;
  }
};
